import { jsx } from 'react/jsx-runtime';
import { styled } from 'styled-components';
import { cssVar } from '@fabric-app/ui/theme/variables';
import StateSpinner, { useResourceLoadingStateIndicatorProps } from '../../../StateSpinner.js';
import { containerPreviewCompact } from '../cssPreviewContainer.js';

const Wrapper = styled.div.withConfig({
  displayName: "ResourceGridViewLoadingIndicator__Wrapper",
  componentId: "sc-f8b5850c-0"
})([
  `position:absolute;color:`,
  `;top:0;right:0;bottom:0;left:0;display:flex;align-items:flex-end;justify-content:flex-end;padding:13px 12px;z-index:11;transition:background-color 0.3s ease-in-out;will-change:background-color;[data-draft='true'] &{background-color:rgba(`,
  `,0.7);}[data-view-mode='List'] &{padding:0;padding-left:19.5px;justify-content:flex-start;align-items:center;border-radius:4px;}`,
  `{align-items:flex-start;}`
], cssVar["color-app-primary"], cssVar["color-bg-primary-rgb"], containerPreviewCompact);
const ResourceGridViewLoadingIndicator = ({ resource }) => {
  const { isIndexing, showIndicator } = useResourceLoadingStateIndicatorProps(resource);
  return showIndicator && /* @__PURE__ */ jsx(Wrapper, {
    children: /* @__PURE__ */ jsx(StateSpinner, {
      size: 22,
      isIndexing
    })
  });
};

export { ResourceGridViewLoadingIndicator };
//# sourceMappingURL=ResourceGridViewLoadingIndicator.js.map
